import { type Client } from '@microsoft/microsoft-graph-client';

interface SendMailOptions {
  to: string;
  subject: string;
  htmlBody: string;
  attachmentName?: string;
  attachmentContent?: ArrayBuffer;
}

export async function sendMail(
  client: Client,
  options: SendMailOptions,
): Promise<void> {
  const message: Record<string, unknown> = {
    subject: options.subject,
    body: {
      contentType: 'HTML',
      content: options.htmlBody,
    },
    toRecipients: [
      {
        emailAddress: { address: options.to },
      },
    ],
  };

  if (options.attachmentName && options.attachmentContent) {
    const base64Content = arrayBufferToBase64(options.attachmentContent);
    message.attachments = [
      {
        '@odata.type': '#microsoft.graph.fileAttachment',
        name: options.attachmentName,
        contentType:
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        contentBytes: base64Content,
      },
    ];
  }

  await client.api('/me/sendMail').post({ message, saveToSentItems: true });
}

function arrayBufferToBase64(buffer: ArrayBuffer): string {
  const bytes = new Uint8Array(buffer);
  let binary = '';
  for (let i = 0; i < bytes.byteLength; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return btoa(binary);
}
